import writeXlsxFile from "write-excel-file";

export async function tableDownload(array, headers, columnsWidth, name) {
  let tabela = [];
  let keys = array.length > 0 ? Object.keys(array[0]) : [];
  let header = [];
  let columns = [];

  headers.forEach((key) => {
    header.push({
      value: key,
      backgroundColor: "#0F0742",
      color: "#ffffff",
    });
  });
  tabela.push(header);

  array.forEach((element) => {
    let row = [];
    keys.forEach((key) => {
      row.push({ value: element[key] });
    });
    tabela.push(row);
  });

  columnsWidth.forEach((width) => {
    columns.push({ width: width });
  });

  writeXlsxFile(tabela, {
    columns: columns,
    fileName: `${name}.xlsx`,
  });
}